if (typeof window !== "undefined") {
  window.global = window;
}
import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import {ErrorBoundaryApp} from "./components/ErrorBoundaryHandler/ErrorBoundaryApp";
import "./index.css";
import {useThemeStore} from "./store/useTheme.store";
import "./Infra/lang/index.js";
import {initAnalytics} from "./Infra/analytics/posthog.js";
import {isChunkLoadError, reloadOnceForChunkError, resetChunkReloadGuardIfNeeded} from "./util/chunkLoadError";

resetChunkReloadGuardIfNeeded();

window.addEventListener("vite:preloadError", event => {
  event.preventDefault();
  reloadOnceForChunkError();
});

window.addEventListener("error", event => {
  const message = event?.message || event?.error?.message || "";
  if (!isChunkLoadError(message)) return;

  event.preventDefault();
  reloadOnceForChunkError();
});

window.addEventListener("unhandledrejection", event => {
  if (!isChunkLoadError(event.reason)) return;

  event.preventDefault();
  reloadOnceForChunkError();
});

useThemeStore.getState().initTheme();
initAnalytics();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundaryApp>
      <App />
    </ErrorBoundaryApp>
  </React.StrictMode>
);
